import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {DialogAlertData} from "../dialog-alert/dialog-alert.component";

/**
 * Dialog data
 */
export class DialogConfirmData extends DialogAlertData {
  constructor(title: String, text: String) {
    super(title, text);
  }
}

/**
 * Delete dialog template
 *
 * Using with MatDialog:
 *
 ```
 // Open dialog
 const dialogRef = this.dialog.open(DialogConfirmComponent, {
     data: new DialogConfirmData('Are you sure?', 'If you do this bad things will happen')
 });

 // Callback for when dialog is closed
 const result = dialogRef.afterClosed().toPromise()
 if (result) {
   // Confirmed!
 } else {
   // Refused...
 }
 ```
 */
@Component({
  selector: 'kis-dialog-confirm',
  templateUrl: './dialog-confirm.component.html',
  styleUrls: ['./dialog-confirm.component.scss']
})
export class DialogConfirmComponent implements OnInit {

  /**
   * @param dialogRef - to use dialog operations
   * @param data - data to be injected
   */
  constructor(public dialogRef: MatDialogRef<DialogConfirmComponent>,
              @Inject(MAT_DIALOG_DATA) public data: DialogConfirmData) {}

  ngOnInit(): void {
  }

}
